import MuiBox, { BoxProps } from '@mui/material/Box';

export interface IBoxProps extends BoxProps {}

const Box = (props: IBoxProps): JSX.Element => {
  return <MuiBox {...props} />;
};

export default Box;
